



import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import ProductState from '@/models/Products/ProductState';

@Component({ name: 'ProductState', })
export default class extends SaascadaVue {

    @Prop({ required: true })
    state: ProductState;

    get textColor() {
        var color: string = "grey--text";
        switch (this.state) {
            case ProductState.Pending:
                color = "warning--text";
                break;
            case ProductState.Published:
                color = "success--text";
                break;
            case ProductState.Withdrawn:
                color = "error--text";
                break;
        }
        return color;
    }

}
